module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-U_Pod.ac492dbf.jpg";